export default __webpack_public_path__ + "static/media/harvard.49ab4b4f.png";